import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserDetailsService } from '../../shared/services/user-details.service';
import { AuthService } from '../../_auth/auth.service';

@Component({
  selector: 'app-searchpanel',
  templateUrl: './searchpanel.component.html',
  styleUrl: './searchpanel.component.scss',
  standalone: false
})
export class SearchpanelComponent implements OnInit, OnChanges {
  searchForm: FormGroup;
  dateTime: Date = new Date();
  @Output() searchResults: EventEmitter<any> = new EventEmitter();
  @Output() isAirmenAgentSearch: EventEmitter<boolean> = new EventEmitter();
  @Output() resetPagination: EventEmitter<boolean> = new EventEmitter();
  @Input() searchType: string;
  @Input() onPageChange: any;
  @Input() sortOrder: any;
  @Input() onAgentDelete: any;
  @Input() onOperatorEdit: any;
  isResetPagination:boolean = false;
  isTechSupportUser:boolean = false;

  userRoles: any[];
  agentCategory = false;
  skipValue: number = 0;
  takeValue: number = 100;
  sortDirection: string = 'Descending';
  propertyName: string = 'lastUpdateDate';


  constructor(private readonly fb: FormBuilder, private readonly userDetailService: UserDetailsService, private authService: AuthService) { 
    this.isTechSupportUser = this.authService.isTechSupportUser();
  }

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      firstName: [''],
      lastName: [''],
      middleName:[''],
      ftn: [''],
      email: [''],
      startDate: [''],
      endDate: [''],
      selectedRole: [''],
      nNumber: [''],
      serialNumber: [''],
      selectedCategory: [false]
    });
    this.handleSearch(); // default the search screen with results
    if (this.searchType == "InternalUser") {
      this.userDetailService.getAllRoles().subscribe((data) => {   
        this.userRoles = data;      
        if (!this.isTechSupportUser)
        {
            this.userRoles = this.userRoles.filter(i => i.roleId !== 1);
        }         
      });
    }
    this.searchForm.get('selectedCategory')?.valueChanges.subscribe((typeOfAgent: any) => {
      this.skipValue = 0;
      this.takeValue = 100;
      this.sortDirection = 'Descending';
      this.propertyName = 'lastUpdateDate';
      if (typeOfAgent === false) {
        // this.searchForm.reset();
        // this.searchForm.get('selectedCategory')?.setValue(false);
        this.agentCategory = false;
        this.handleSearch();
      }
      else if (typeOfAgent === true) {
        // this.searchForm.reset();
        // this.searchForm.get('selectedCategory')?.setValue(true);
        this.agentCategory = true;
        this.handleSearch();
      }
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes?.onPageChange?.currentValue);
    if (changes?.onPageChange?.currentValue) {
      this.skipValue = changes?.onPageChange?.currentValue?.first;
      this.takeValue = changes?.onPageChange?.currentValue?.first + 100;
      this.isResetPagination = false;
      this.handleSearch();
    }
    if (changes?.sortOrder?.currentValue) {
      this.sortDirection = changes?.sortOrder?.currentValue.order;
      this.propertyName = changes?.sortOrder?.currentValue.field;
      this.handleSearch();
    }

    if (changes?.onAgentDelete?.currentValue) {      
      this.handleSearch();
    }

  }

  handleSearch() {
    if (this.searchType == "Airman/Operator" || this.searchType == "EditOperator") {
      if (this.agentCategory) {
        const data = {
          skip: this.skipValue,
          take: this.takeValue,
          operatorFirstName: this.searchForm.controls['firstName'].value,
          operatorLastName: this.searchForm.controls['lastName'].value,
          nNumber: this.searchForm.controls['nNumber'].value,
          serialNo: this.searchForm.controls['serialNumber'].value,
          updatedFrom: this.searchForm.controls['startDate'].value,
          updatedTo: this.searchForm.controls['endDate'].value,
          orderBy: [
            {
              sortDirection: this.sortDirection,
              propertyName: (this.searchType == "EditOperator") ? "operatorFirstName" : this.propertyName
            }
          ]
        }
        if(this.searchType == "EditOperator"){
          this.userDetailService.SearchArOwnerDetails(data).subscribe((results) => {
              this.isAirmenAgentSearch.emit(false);
              this.searchResults.emit(results);
              this.resetPagination.emit(this.isResetPagination);
            })  
        }
        else{
            this.userDetailService.getArOwnerSearchAgent(data).subscribe((results) => {
              this.isAirmenAgentSearch.emit(false);
              this.searchResults.emit(results);
              this.resetPagination.emit(this.isResetPagination);
        })  
        }

      }
      else {
        const data = {
          skip: this.skipValue,
          take: this.takeValue,
          operatorFirstName: this.searchForm.controls['firstName'].value,
          operatorLastName: this.searchForm.controls['lastName'].value,
          FTN: this.searchForm.controls['ftn'].value,
          operatorEmail: this.searchForm.controls['email'].value,
          updatedFrom: this.searchForm.controls['startDate'].value,
          updatedTo: this.searchForm.controls['endDate'].value,
          orderBy: [
            {
              sortDirection: this.sortDirection,
              propertyName: (this.searchType == "EditOperator") ? "operatorFirstName" : this.propertyName
            }
          ]
        }
        if(this.searchType == "EditOperator"){
          this.userDetailService.SearchAirmenDetails(data).subscribe((results) => {
            this.isAirmenAgentSearch.emit(true);
            this.searchResults.emit(results);
            this.resetPagination.emit(this.isResetPagination);
          })
        }
        else{
          this.userDetailService.getSearchAgent(data).subscribe((results) => {
            this.isAirmenAgentSearch.emit(true);
            this.searchResults.emit(results);
            this.resetPagination.emit(this.isResetPagination);
        })
        }
      }
    }
    else if (this.searchType == "InternalUser") {
      const data = {
        skip: this.skipValue,
        take: this.takeValue,
        firstName: this.searchForm.controls['firstName'].value,
        lastName: this.searchForm.controls['lastName'].value,
        email: this.searchForm.controls['email'].value,
        roleId: this.searchForm.controls['selectedRole'].value,
        isTechSupport : this.isTechSupportUser
      }
      this.userDetailService.getInternalUsers(data).subscribe((results) => {
        this.searchResults.emit(results);
      })
    }else if(this.searchType == "externalUser"){
      const data = {
        skip: this.skipValue,
        take: this.takeValue,
        firstName: this.searchForm.controls['firstName'].value,
        middleName: this.searchForm.controls['middleName'].value,
        lastName: this.searchForm.controls['lastName'].value,
        email: this.searchForm.controls['email'].value,
        orderBy: [
          {
            sortDirection: this.sortDirection,
            propertyName: "firstName" 
          }
        ]
      }
      this.userDetailService.getExternalUsers(data).subscribe((results) => {
        this.searchResults.emit(results);
        this.resetPagination.emit(this.isResetPagination);
      })
    }
  }

  clearSearch() {
    this.searchForm.reset();
    this.searchForm.get('selectedCategory')?.setValue(false);
    this.skipValue = 0;
    this.takeValue = 100;
    this.handleSearch();
    this.resetPagination.emit(true);
    this.isResetPagination = true;
  }
  search(){
    this.skipValue = 0;
    this.takeValue = 100;
    this.sortDirection = 'Descending';
    this.propertyName = 'lastUpdateDate';
    this.handleSearch();
    this.isResetPagination = true;
  }
}
